import { styled } from '../../../core/theme/styled';

export const StyledContainerWithCorners = styled.div`
  position: relative;
  padding: ${(props) => props.theme.sizes.xxsmall};
  margin-left: auto;
  margin-right: auto;

  &:before,
  &:after,
  & > :first-child:before,
  & > :first-child:after {
    position: absolute;
    min-width: 25px;
    min-height: 25px;
    border-color: ${(props) => props.theme.configuration.strokeColor};
    border-style: solid;
    content: ' ';
  }
  &:before {
    top: 0;
    left: 0;
    border-width: 3px 0 0 3px;
    border-top-left-radius: ${(props) => props.theme.roundedCorners.medium};
  }
  &:after {
    top: 0;
    right: 0;
    border-width: 3px 3px 0 0;
    border-top-right-radius: ${(props) => props.theme.roundedCorners.medium};
  }
  & > :first-child:before {
    bottom: 0;
    right: 0;
    border-width: 0 3px 3px 0;
    border-bottom-right-radius: ${(props) => props.theme.roundedCorners.medium};
  }
  & > :first-child:after {
    bottom: 0;
    left: 0;
    border-width: 0 0 3px 3px;
    border-bottom-left-radius: ${(props) => props.theme.roundedCorners.medium};
  }
`;
